import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const ChevronRight: FunctionalComponent<IIconProps> = ({ width = 24, height = 24, fill = '#666' }) => (
  /*@ts-ignore*/
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5826 12L9.29268 6.70689C8.90227 6.31625 8.90246 5.68309 9.29311 5.29268C9.68375 4.90227 10.3169 4.90246 10.7073 5.29311L16.7037 11.2931C16.8988 11.4884 16.9964 11.7442 16.9964 12C16.9964 12.2558 16.8988 12.5116 16.7037 12.7069L10.7073 18.7069C10.3169 19.0975 9.68375 19.0977 9.29311 18.7073C8.90246 18.3169 8.90227 17.6837 9.29268 17.2931L14.5826 12Z"
      fill={fill}
    />
  </svg>
);

export default ChevronRight;
